import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { AdvertiserCreationFormComponent } from '../../components/advertiser-creation-form/advertiser-creation-form.component';
import { Advertiser } from '~core/models/advertiser.models';

@Component({
  selector: 'advertiser-creation-dialog',
  standalone: true,
  imports: [AdvertiserCreationFormComponent],
  templateUrl: './advertiser-creation-dialog.component.html',
  styleUrl: './advertiser-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertiserCreationDialogComponent extends BaseComponent {
  advertiser = input<Advertiser>();
}
